// saleskit/api.js
const BASE_URL = '/minierp/saleskit';

function getToken() {
  return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken') || '';
}

async function request(path, { method = 'GET', body, params } = {}) {
  let url = `${BASE_URL}${path}`;
  if (params) {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null)
    ).toString();
    if (qs) url += `?${qs}`;
  }

  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    throw new Error(json.message || `Request failed (${res.status})`);
  }
  return json.data;
}

// Companies
export const listCompanies = (params) => request('/companies', { params });
export const getCompany = (id) => request(`/companies/${id}`);
export const createCompany = (body) => request('/companies', { method: 'POST', body });
export const updateCompany = (id, body) => request(`/companies/${id}`, { method: 'PUT', body });
export const deleteCompany = (id) => request(`/companies/${id}`, { method: 'DELETE' });
export const toggleFavouriteCompany = (id) => request(`/companies/${id}/favourite`, { method: 'PATCH' });

// Products
export const listProducts = (params) => request('/products', { params });
export const getProduct = (id) => request(`/products/${id}`);
export const createProduct = (body) => request('/products', { method: 'POST', body });
export const updateProduct = (id, body) => request(`/products/${id}`, { method: 'PUT', body });
export const deleteProduct = (id) => request(`/products/${id}`, { method: 'DELETE' });

// Generator
export const generateSalesKit = (body) => request('/generate', { method: 'POST', body });
